export default __webpack_public_path__ + "static/media/Roboto-Regular.31012f9b.woff";